import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select, Table, TableBody, TableCell, TableHead, TableRow,
  TextField, Typography
} from '@mui/material';
import Box from '@mui/material/Box';
import removeButton from '../../../icons/remove.png';
import * as React from 'react';
import { useEffect } from 'react';
import axios from 'axios';
import { getApiBaseUrl } from '../../../utils/env';
import { ReactComponent as PencilIcon } from '../../../icons/pencil.svg';

const removeOrgMedia = async (id: number) => {
  await axios.delete(`${getApiBaseUrl()}/organisation-social-media/${id}`);
};

type MediaItem = {
  id: number,
  type: string,
  channelUrl: string,
  channelId: string,
  initialSize: number,
  enabled: boolean,
}

const fetchOrgMedia = async (domain) => {
  const { data } = await axios.get(`${getApiBaseUrl()}/organisation-social-media/${domain}/list`);
  return data;
};

const addOrgMedia = async (
  org_id: number,
  type: string,
  channelUrl: string, initialSize: number, enabled: boolean
) => {
  await axios.post(`${getApiBaseUrl()}/organisation-social-media`, {
    type,
    org_id,
    channel_url: channelUrl,
    initial_size: initialSize,
    enabled,
  });
};

const editOrgMedia = async (
  id: number,
  org_id: number,
  type: string,
  channelUrl: string, initialSize: number, enabled: boolean
) => {
  await axios.patch(`${getApiBaseUrl()}/organisation-social-media/${id}`, {
    id,
    type,
    org_id,
    channel_url: channelUrl,
    initial_size: initialSize,
    enabled,
  });
};

export const SocialMediaImporter = ({ organisation }) => {
  const [socialMediaTypes] = React.useState(['YouTube', 'Instagram', 'Tiktok']);
  const [selectedType, setSelectedType] = React.useState('');
  const [url, setUrl] = React.useState('');
  const [initialSize, setInitialSize] = React.useState(10);
  const [enabled, setEnabled] = React.useState(false);
  const [selectedId, setSelectedId] = React.useState<number>();

  const [medias, setMedias] = React.useState<MediaItem[]>([]);

  const reset = () => {
    setUrl('');
    setEnabled(false);
    setInitialSize(10);
    setSelectedType('');
    setSelectedId(undefined);
  };

  useEffect(() => {
    fetchOrgMedia(organisation.domain).then((results) => {
      setMedias(results);
    });
  }, [organisation.domain]);
  return (<Grid container spacing={2} style={{ marginTop: 0 }}>
    <Grid item xs={4}>
      <form onSubmit={(e) => {
        e.preventDefault();
        if (selectedId) {
          editOrgMedia(selectedId, organisation.id as number, selectedType, url, initialSize, enabled)
            .then(() => {
              fetchOrgMedia(organisation.domain).then((results) => {
                setMedias(results);
                reset();
              });
            });
        } else {
          addOrgMedia(organisation.id as number, selectedType, url, initialSize, enabled)
            .then(() => {
              fetchOrgMedia(organisation.domain).then((results) => {
                setMedias(results);
                reset();
              });
            });
        }
      }}>
        <Grid container spacing={2} style={{ marginTop: 0 }}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel required id="social-media-type-label">Social Media
                Type</InputLabel>
              <Select
                required
                labelId="social-media-type-label"
                id="social-media-type"
                value={selectedType}
                label="Social Media Type"
                onChange={(e) => setSelectedType(e.target.value)}
              >
                {socialMediaTypes.map((type) => (
                  <MenuItem key={type} value={type.toLowerCase()}>{type}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <TextField required value={url} id="channelURL" label="Channel URL"
                         variant="outlined"
                         type={'url'} onChange={(e) => setUrl(e.target.value)}/>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              {/*<InputLabel id="initialSizeVideoToImportLabel">Initial number of video to import</InputLabel>*/}
              <TextField id="initialSizeVideoToImport"
                         value={initialSize}
                         required
                         onChange={(e) => setInitialSize(parseInt(e.target.value))}
                         label="Initial number of video to import"
                         variant="outlined"
                         type={'number'}/>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <FormControlLabel
                control={<Checkbox checked={enabled}
                                   onChange={(e) => setEnabled(e.target.checked)}/>}
                label="Enabled"
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <Grid container justifyContent={'space-between'}>
              <Button variant="outlined" onClick={() => reset()}>Reset</Button>
              <Button variant="contained" type={'submit'} color="primary">Save</Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </Grid>
    <Grid item xs={8}>
      {medias.length === 0 && (<Typography>No saved item yet</Typography>)}
      {medias.length > 0 && (<Table>
        <TableHead>
          <TableRow>
            <TableCell>Type</TableCell>
            <TableCell>URL</TableCell>
            <TableCell>Initial size</TableCell>
            <TableCell>Enabled</TableCell>
            <TableCell>Edit</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {medias.map((media) => (
            <TableRow key={media.channelId}>
              <TableCell>{media.type}</TableCell>
              <TableCell><Box title={media.channelUrl} sx={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '120px',
              }}>{media.channelUrl}</Box></TableCell>
              <TableCell>{media.initialSize}</TableCell>
              <TableCell>{media.enabled ? 'Yes' : 'No'}</TableCell>
              <TableCell>
                <Grid container justifyContent={'space-around'} spacing={1}>
                  <Grid item>
                    <PencilIcon style={{ cursor: 'pointer' }}
                                onClick={() => {
                                  setUrl(media.channelUrl);
                                  setEnabled(media.enabled);
                                  setInitialSize(media.initialSize);
                                  setSelectedType(media.type);
                                  setSelectedId(media.id);
                                }}
                    />
                  </Grid>
                  <Grid item>
                      <span onClick={async () => {
                        if (window.confirm('Are you sure you want to remove this config?')) {
                          await removeOrgMedia(media.id);
                          fetchOrgMedia(organisation.domain).then((results) => {
                            setMedias(results);
                          });
                        }
                      }} style={{ cursor: 'pointer' }}><img
                        width={20}
                        src={removeButton}
                        alt="Remove config"/></span>
                  </Grid>
                </Grid>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>)}

    </Grid>
  </Grid>);
};